import { createColor } from '@manakin/theme/lib/color';

const mountain = createColor('#1a1919');

export default mountain;
